var map = {
	"./Chery_thumbnail.png": "2639",
	"./GWM_thumbnail.png": "a8eb",
	"./Magirus-Deutz_thumbnail.png": "7461",
	"./alfa-romeo_thumbnail.png": "bc80",
	"./audi_thumbnail.png": "c933",
	"./bell_thumbnail.png": "f385",
	"./bmw_thumbnail.png": "da7f",
	"./case_thumbnail.png": "7cfb",
	"./chevrolet_thumbnail.png": "8bc9",
	"./claas_thumbnail.png": "b34f",
	"./datsun_thumbnail.png": "da01",
	"./dodge_thumbnail.png": "307f",
	"./faw_thumbnail.png": "d3f4",
	"./fiat_thumbnail.png": "fad6",
	"./ford_thumbnail.png": "ad30",
	"./foton_thumbnail.png": "8872",
	"./freightliner_thumbnail.png": "5c22",
	"./haval_thumbnail.png": "293a",
	"./hino_thumbnail.png": "af76",
	"./honda_thumbnail.png": "7a3c",
	"./hyundai_thumbnail.png": "b6b7",
	"./international_thumbnail.png": "bacc",
	"./isuzu_thumbnail.png": "b056",
	"./iveco_thumbnail.png": "63af",
	"./jaguar_thumbnail.png": "4764",
	"./jcb_thumbnail.png": "bd18",
	"./jeep_thumbnail.png": "9422",
	"./jmc_thumbnail.png": "04ce",
	"./johndeere_thumbnail.png": "438e",
	"./kia_thumbnail.png": "f56b",
	"./komatsu_thumbnail.png": "d6f2",
	"./landrover_thumbnail.png": "7627",
	"./mahindra_thumbnail.png": "9322",
	"./man_thumbnail.png": "304c",
	"./masseyferguson_thumbnail.png": "5ade",
	"./mazda_thumbnail.png": "5c24",
	"./mercedes_thumbnail.png": "7f95",
	"./mg_thumbnail.png": "cf2b",
	"./mitsubishi_thumbnail.png": "e766",
	"./nissan_thumbnail.png": "5bda",
	"./peterbilt_thumbnail.png": "011d",
	"./powerstar_thumbnail.png": "8235",
	"./renault_thumbnail.png": "4713",
	"./rollsroyce_thumbnail.png": "fc88",
	"./samil_thumbnail.png": "26e1",
	"./ssangyong_thmbnail.png": "0c71",
	"./subaru_thumbnail.png": "6c19",
	"./suzuki_thumbnail.png": "0542",
	"./tata_thumbnail.png": "4aa5",
	"./toyota_thumbnail.png": "6dc3",
	"./volkswagen_thumbnail.png": "2699",
	"./volvo_thumbnail.png": "230b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d6b5";